<template>
  <section class="flex justify-center section-gala items-center relative">
    <div class="container">
      <div
        class="
          alex-intro
          -m-2
          w-5/6
          sm:w-full
          lg:w-6/6
          justify-center
          sm:justify-between
        "
      >
        <div class="p-3 md:w-2/3 md:text-left">
          <img
            src="../../../../../../src/assets/images/pages/gala/gala-logo.svg"
            width="220px"
            class="mb-2 mt-12"
          />
          <h1 class="text-white text-left mt-6  text-3xl md:text-5xl">
           <b> Find your role</b>
          </h1>
          <p class="text-white text-left mt-6">
            Build your “character” to  <i>build your character</i>.
          </p><br><br>
          <p class="text-white text-left mt-2">
            Through imaginative self-discovery, we will find new ways to
          </p>
          <p class="text-white text-left mt-2">
            develop  ourselves and bring us closer together.
          </p>
<!--          <img-->
<!--            src="../../../../../../src/assets/images/gala-images/home-logo.png"-->
<!--            class="heading"-->
<!--          />-->
        </div>
        <div
          class="
            lg:-mr-4
            text-center
            md:w-1/3
            p-4
            flex
            justify-center
            ml-4
            mt-12
          "
        >
          <img
            src="../../../../../../src/assets/images/gala-images/logo_branded/Hero_image.png"
            width="690px"
          />

        </div>
      </div>
    </div>
<!--    <div class="absolute home-icon">-->
<!--      <img-->
<!--      class="home-icon-img"-->
<!--        src="../../../../../../src/assets/images/gala-images/home-logo.png"-->
<!--      />-->
<!--    </div>-->
  </section>
</template>
<script>
export default {
  name: "Header",
};
</script>
<style scoped>

section {
  position: relative;
  min-height: 85vh;
  background: url("../../../../../../src/assets/images/gala-images/logo_branded/background.png")
    center;
  background-size: cover;
}
.heading {
   width: 50%;
   font-weight: bolder;
   width: 10em;
   position: absolute;
   top: 89%;
   left: 11%;
 }

.alex-intro {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  padding: 4%;
}
.alex-intro p {
  font-size: 21px;
}
#login {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  /* line-height: 22px; */
  /* letter-spacing: -0.01em; */
  color: #3280fc;
  color: #3280fc;
  background: #ffffff;
  border-radius: 4px;

  padding: 10px 20px;
}
.home-icon {
  bottom: -9.5em;
  left: 22em;
}

@media only screen and (max-width: 600px) {
  .home-icon {
    left: 2.5em;
    bottom: -5.5em;
  }
  .home-icon-img {
    width: 8em;
  }
  .heading {
    font-weight: bolder;
    width: 95%;
    font-size: 1em !important;
    width: 5.5em;
    top: 97%;
    left: 2%;

}

}
</style>
